import { useRoutes } from "react-router-dom";
import routers from "./constants/router";

const App = () => {
  let route = useRoutes(routers);
  return route;
};

export default App;
